import { NgModule } from '@angular/core';
import { SharedModule } from "app/shared/shared.module";
import { RouterModule } from "@angular/router";
import { CoreModule } from 'app/core/core.module';
import { ModuleListComponent } from './component/module-list/module-list.component';
import { AddModuleComponent } from './component/add-module/add-module.component';
import { ModuleDetailsComponent } from './component/module-details/module-details.component';
import { ModuleAuditListComponent } from './component/module-audit-list/module-audit-list.component';
import { ModuleAuditAddComponent } from './component/module-audit-add/module-audit-add.component';
import { ModuleService } from './services/module.service';
import { ModuleQuestionBankAddComponent } from './component/module-question-bank-add/module-question-bank-add.component';
import { MODULE_ROUTES } from './module.routing';
import { ModuleQuestionBankListComponent } from './component/module-question-bank-list/module-question-bank-list.component';

@NgModule({
    imports: [
        CoreModule,
        SharedModule,
        RouterModule.forChild(MODULE_ROUTES)
    ],
    declarations: [
        ModuleListComponent,
        AddModuleComponent,
        ModuleDetailsComponent,
        ModuleAuditListComponent,
        ModuleAuditAddComponent,
        ModuleQuestionBankAddComponent,
        ModuleQuestionBankListComponent
    ],
    providers: [ModuleService]
})
export class ModuleModule { }
